export const LOGIN_EVENT_NAME = 'kcp-login'

export const SESSION_STORAGE_KEYS = {
  INIT: 'KOCOWA_INIT',
  SESSION_START: 'KOCOWA_SESSION_START',
  UPDATED_SIGNIN: 'KOCOWA_UPDATED_SIGNIN',
}

export const resetKCPSessionStorages = () => {
  try {
    const KCP_SESSION_KEYS = [
      SESSION_STORAGE_KEYS.INIT,
      SESSION_STORAGE_KEYS.SESSION_START,
      SESSION_STORAGE_KEYS.UPDATED_SIGNIN,
    ]

    KCP_SESSION_KEYS.forEach(function(sessionKey) {
      if (window.sessionStorage && window.sessionStorage.getItem(sessionKey)) {
        window.sessionStorage.removeItem(sessionKey)
      }
    })
  } catch (e) {
    console.log('session storage error:' + e.message)
  }
}
